/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { MemberManagementListOrderRequest } from '../models/MemberManagementListOrderRequest';
import type { MemberManagementListOrderResponseApiRespoonse } from '../models/MemberManagementListOrderResponseApiRespoonse';
import type { MemberManagementViewOrderRequest } from '../models/MemberManagementViewOrderRequest';
import type { MemberManagementViewOrderResponseApiRespoonse } from '../models/MemberManagementViewOrderResponseApiRespoonse';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class MemberManagementMemberHistoryService {

    /**
     * 購入履歴一覧
     * @param requestBody
     * @returns MemberManagementListOrderResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMemberHistory(
        requestBody: MemberManagementListOrderRequest,
    ): CancelablePromise<MemberManagementListOrderResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/member-history',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

    /**
     * 購入履歴詳細
     * @param requestBody
     * @returns MemberManagementViewOrderResponseApiRespoonse 正常レスポンス
     * @throws ApiError
     */
    public static adminMemberHistoryView(
        requestBody: MemberManagementViewOrderRequest,
    ): CancelablePromise<MemberManagementViewOrderResponseApiRespoonse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/admin/member-history/view',
            body: requestBody,
            mediaType: 'applicatin/json',
            errors: {
                400: `Fail to process.`,
                401: `fail to authentication`,
                419: `token mismatch`,
            },
        });
    }

}
